import { ConstellationAPI } from "../infrastructure/api/Constellation.api";

/**
 * The constellation board, opened inside a call rather than in a tab.
 *
 * The session's board (made on first use, the same one afterwards), the
 * therapist's chrome-less page of it to frame, and a link for the patient —
 * whose page is built from the token rather than taken from the URL the
 * server writes, which names the server's idea of the app's host and would
 * not be same-origin in every environment.
 */
export async function openConstellationInMeeting(sessionId: string): Promise<{
    therapistPath: string;
    patientPath: string;
}> {
    const { data } = await ConstellationAPI.launchForSession(sessionId);
    const boardId = data.board.id;
    const { data: link } = await ConstellationAPI.createShareLink(boardId);
    return {
        therapistPath: embeddedConstellationPath(boardId),
        patientPath: `/constellation/patient/${link.token}`,
    };
}

/** The therapist's board with no app chrome, for framing inside a call. */
export function embeddedConstellationPath(boardId: string): string {
    return `/meeting-board/constellation/${boardId}`;
}
